import request from 'checkout/utils/axios'

const fetchCartShipping = async (postalCode = '') => {
  const url = `/api/v1/shipments${postalCode && `/${postalCode}`}`

  return (await request.get(url)).data
}

export default fetchCartShipping
